import Redactor from '../../redactor.esm.min.js'
import { registerToolbarButton } from '../registerButton'

class MpDividerPlugin {
    constructor(app, options = {}) {
        this.app = app
        this.options = options
    }

    start() {
        const noDividers = this.options.noDividers || 8
        for (let i = 1; i <= noDividers; i++) {
            registerToolbarButton(this.app, `mpDivider${i}`, this._createToolbarButton(`mpDivider${i}`))
        }
    }

    _createToolbarButton(name = 'mpDivider') {
        return {
            title: '',
            name: name,
            html: `<span class="mp-redactor-divider"></span>`,
            classname: 'mp-redactor-divider-btn',
            command: false
        }
    }
}

Redactor.addPlugin('mpDivider', MpDividerPlugin)
